module.exports = __webpack_public_path__ + "img/dt.8224e6ea.png";